import { pack } from "@/utils";

const withFinalForm = (WrappedComponent) => {
  // meta contains information about errors and validation warnings.
  // removed here to prevent dom leaking.
  const WithFinalForm = ({ input, meta, ...props }) => {
    const hasError =
      (meta.error && meta.touched) ||
      (meta.submitError && meta.dirtySinceLastSubmit === false);

    return (
      <WrappedComponent
        {...props}
        {...input}
        error={hasError}
        errorMessage={
          hasError
            ? [...pack(meta.error), ...pack(meta.submitError)]
                .filter(Boolean) // remove undefined
                .join(", ")
            : undefined
        }
      />
    );
  };
  return WithFinalForm;
};

export default withFinalForm;
